var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMainCollection = /* @__PURE__ */ __name(($el, current_sort) => {
  var _a, _b, _c;
  const state = window.Alpine.reactive({
    loading: false,
    count: (_b = (_a = $el.querySelector("[data-next-url]")) == null ? void 0 : _a.children) == null ? void 0 : _b.length,
    sort_by: current_sort,
    next_url: (_c = $el.querySelector("[data-next-url]")) == null ? void 0 : _c.getAttribute("data-next-url")
  });
  const modalStore = window.Alpine.store("modal");
  Alpine.effect(() => {
    if (state.sort_by !== current_sort) {
      Alpine.nextTick(() => {
        updateSortAndFilters();
      });
    }
  });
  const updateSortAndFilters = /* @__PURE__ */ __name(async (url = new URL(`${((_d) => (_d = $el.action) == null ? void 0 : _d.split("?")[0])()}?${new URLSearchParams(new FormData($el)).toString()}`)) => {
    var _a2, _b2, _c2, _d2, _e, _f;
    modalStore.setId("");
    state.loading = true;
    (_a2 = $el == null ? void 0 : $el.querySelectorAll(
      "[class^=product-card--], [class^=collection-card--], [class^=article-card--], [class^=blog-card--], [class^=page-card--]"
    )) == null ? void 0 : _a2.forEach((card) => {
      var _a3;
      (_a3 = card == null ? void 0 : card.classList) == null ? void 0 : _a3.add("button-loading-transparent");
    });
    const content = await fetch(url).then((res) => res.text());
    (_b2 = url == null ? void 0 : url.searchParams) == null ? void 0 : _b2.delete("barba_prefetch");
    barba.history.add(url.toString(), "barba", "replace");
    const newDocument = document.createElement("div");
    newDocument.innerHTML = content;
    const section = newDocument.querySelector(`[data-style-id="${$el.getAttribute("data-style-id")}"]`);
    $el.outerHTML = section.outerHTML;
    state.loading = false;
    state.count = (_d2 = (_c2 = $el.querySelector("[data-next-url]")) == null ? void 0 : _c2.children) == null ? void 0 : _d2.length;
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(0, (_f = (_e = header == null ? void 0 : header.getBoundingClientRect()) == null ? void 0 : _e.bottom) != null ? _f : 0);
    utils.scrollToY(150, utils.getElementPosition($el).top - offsetHeight - +getComputedStyle($el).paddingTop.replace("px", ""));
  }, "updateSortAndFilters");
  const debounceUpdates = utils.debounce(updateSortAndFilters, 750);
  const loadNextPage = /* @__PURE__ */ __name(async (container = $el.querySelector(`[data-next-url]`), paginationContainer = $el.querySelector(`[data-pagination][x-ref="pagination"]`)) => {
    var _a2;
    if (!state.next_url || state.loading) return;
    state.loading = true;
    const html = await fetch(state.next_url).then((res) => res.text());
    const newDocument = document.createElement("div");
    newDocument.innerHTML = html;
    const section = newDocument.querySelector(`[data-style-id="${$el.getAttribute("data-style-id")}"]`);
    const newContent = section.querySelector(`[data-next-url][x-ref="${container == null ? void 0 : container.getAttribute("x-ref")}"]`);
    state.next_url = newContent == null ? void 0 : newContent.getAttribute("data-next-url");
    const newPagination = section.querySelector(`[data-pagination][x-ref="pagination"]`);
    if (newContent) {
      container.append(...newContent.children);
      state.count = (_a2 = container == null ? void 0 : container.children) == null ? void 0 : _a2.length;
    }
    if (paginationContainer && newPagination) {
      paginationContainer.innerHTML = newPagination.innerHTML;
    }
    state.loading = false;
  }, "loadNextPage");
  return {
    main_collection: {
      state,
      loadNextPage,
      updateSortAndFilters,
      debounceUpdates
    }
  };
}, "initMainCollection");
window._sections["initMainCollection"] = initMainCollection;
